import React from 'react';
import PropTypes from 'prop-types';

import { formatDate, formatTime } from '../../../utils/dateFunctions';

import card from '../../../commonStyles/rowExpand.module.css';

const StatusHistory = ({ history }) => {
    return (
        <div className={card.cardView}>
            <div className={card.banner}>
                <span>Email: {history.emailAddress} </span>
                <span>Date: {formatDate(history.date) || ' - '}</span>
                <span>Time: {formatTime(history.date) || ' - '} </span>
                <span>New Status: {history.status || ' - '}</span>
            </div>

            <div className={card.content}>
                <p>
                    <span className={card.label}>Reason: {history.reason || 'N/A'}</span>
                </p>
                <p>
                    <span className={card.label}> Notes: {history.notes || ' - '}</span>
                </p>
            </div>
        </div>
    );
};

StatusHistory.propTypes = {
    history: PropTypes.object
};

export default StatusHistory;
